'use strict';

var $ = require('jquery'),
    UrlUtils = require('../../url-utils');

function getDocumentDoctype() {
    var node,
        doctype;

    if (typeof document.doctype == 'undefined' || !document.doctype) {
        return '<!DOCTYPE html>';
    }

    node = document.doctype;
    doctype = '<!DOCTYPE '
        + node.name
        + (node.publicId ? ' PUBLIC "' + node.publicId + '"' : '')
        + (!node.publicId && node.systemId ? ' SYSTEM' : '')
        + (node.systemId ? ' "' + node.systemId + '"' : '')
        + '>';
    return doctype;
}

function supportsHtmlSerialize() {
    return $.support.htmlSerialize;
}

function copyPropsToAttrs(el) {
    var tagName = el.tagName.toLowerCase();

    if (tagName == 'input') {
        if(el.checked) {
            el.setAttribute('checked', 'checked');
        } else {
            el.removeAttribute('checked');
        }
    } else if (tagName == 'option') {
        if(el.selected) {
            el.setAttribute('selected', 'selected');
        } else {
            el.removeAttribute('selected');
        }
    }
}

function cloneBody() {
    var $body = $('body'),
        fakeElement;

    if (!supportsHtmlSerialize()) {
        fakeElement = document.createElement('div');
        fakeElement.innerHTML = $body[0].innerHTML;
        return $(fakeElement);
    }

    $body.find('*').each(function () {
        copyPropsToAttrs(this);
    });

    return $body.clone();
}

function cloneHead() {
    if (!supportsHtmlSerialize()) {
        return $();
    }

    return $('head').clone();
}

function serializeHead($head) {
    var headStr;

    if (!supportsHtmlSerialize()) {
        headStr = $('head').html().replace(/<script[\s\S]*?<\/script>/gmi, '');
        return headStr.replace(/href="(.+?)"/gmi, function (match, url) {
            return 'href="' + Url.absolute(url) + '"';
        });
    }

    return $head.html();
}

function makeHrefAbsolute(el) {
    var href = el.getAttribute('href');

    if (href && !href.match(/^mailto:/) && !href.match(/^#/)) {
        el.setAttribute('href', UrlUtils.absolute(href));
    }
}

function makeSrcAbsolute(el) {
    var src = el.getAttribute('src');

    if (src && !src.match(/^data:/)) {
        el.setAttribute('src', UrlUtils.absolute(src));
    }
}

function makeBgUrlAbsolute(el) {
    var $el = $(el),
        bg = $el.css('background-image'),
        url;

    if (bg && bg.match(/^url\(/) && bg.match(/^^url\(data:/)) {

        if (bg[4] == '\'' || bg[4] == '"') {
            url = UrlUtils.absolute(bg.substr(5, bg.length - 7));
        } else {
            url = UrlUtils.absolute(bg.substr(4, bg.length - 5));
        }

        $el.css('background-image', 'url("' + url + '")');
    }
}

function removeZeroOpacity(el) {
    var $el = $(el);

    if ($el.css('opacity') === 0) {
        $el.css('opacity', 100);
    }
}

function prepareNodeToSerialization(el) {
    switch (el.tagName.toLowerCase()) {
        case 'script':
            el.parentNode.removeChild(el);
            break;
        case 'a':
        case 'link':
            makeHrefAbsolute(el);
            break;
        case 'img':
            makeSrcAbsolute(el);
            break;
    }

    makeBgUrlAbsolute(el);
    removeZeroOpacity(el);
}

function shouldBeExcluded(el, excludeSelector) {
    return excludeSelector && $(el).is(excludeSelector);
}

function pageSnapshotTpl(data) {
    return data.doctype + '<html><head>' + data.head + '</head><body>' + data.body + '</body></html>';
}

function pageHtmlSnapshot(opt) {
    var doctype = getDocumentDoctype(),
        $head = cloneHead(),
        $body = cloneBody(),
        excludeSelector = opt && opt.excludeSelector,
        $elements;

    if ($head.length) {
        $elements = $([$head[0], $body[0]]);
    } else {
        $elements = $body;
    }

    $elements.find('*').each(function () {
        if(shouldBeExcluded(this, excludeSelector)){
            this.parentNode.removeChild(this);
        } else {
            prepareNodeToSerialization(this);
        }
    });

    return pageSnapshotTpl({
        doctype: doctype,
        head: serializeHead($head),
        body: $body.html()
    });
}

module.exports = pageHtmlSnapshot;
